<template>
  <div id="payment" class="below-header">
    <b-overlay :show="loading" rounded="sm">
      <div class="container">

        <div>
          <div class="grid grid-cols-2 gap-10">
            <b-card v-for="card in cards" :key="card.id" class="d-inline-flex">
              <b-card-body class="d-inline-flex text-left w-100">
                <div class="flex-shrink-0 ">
                  <img :src="'/'+card.card.brand + '.svg'" width="35" class="mr-2"> <span class="ml-2">**** **** **** {{card.card.last4}}</span>
                  <span class="ml-2">{{card.card.exp_month}}/{{card.card.exp_year}}</span>
                </div>
              </b-card-body>
            </b-card>
          </div>

          <div class="mt-3">
            <b-button variant="primary" @click="createCustomerPortal" :disabled="stripeMixin.loading">
              {{ $t("billing.payment.manageCards") }}
            </b-button>
          </div>
        </div>
      </div>
    </b-overlay>

  </div>
</template>

<script>
import StripeMixin from "@/mixins/StripeMixin";

export default {
  mixins: [StripeMixin],
  async mounted() {
    this.getSavedCards();
  },

  data() {
    return{
      loading: false,
      hasCard: null,
      cards: [],
      error: null,
    }
  },

  methods: {
    getSavedCards() {
      this.loading = true;
      this.axios.get('/billing/stripe/saved-card').then(res=>{
        if(res.data.length === 0) {
          this.hasCard = false;
          return;
        }
        this.hasCard =  true;
        this.cards = res.data;
      }).catch(e=>{
        console.error(e);
      }).finally(()=>{
        this.loading = false;
      })
    }
  }
}
</script>